/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHistory } from 'react-router';

import { SetCurrentPage } from 'features/Onboarding/common/useManageCurrentPage/types';

/**
 * We override setCurrentPage and replace it by a function that
 * - sets the requested query params in the URL,
 * - sends to the machine an event which type is the OnboardingPage to navigate to.
 */
const useOverrideSetCurrentPage = (callback: (target: any) => void) => {
  const history = useHistory();

  const setCurrentPage: SetCurrentPage = (page, options) => {
    const params = new URLSearchParams(options?.queryParams).toString();

    history.replace(
      `${history.location.pathname}${params ? `?${params}` : ''}`,
    );

    return callback(page as any);
  };

  return setCurrentPage;
};

export default useOverrideSetCurrentPage;
